import { render, staticRenderFns } from "./GoToLink.vue?vue&type=template&id=12316ac2&scoped=true"
import script from "./GoToLink.vue?vue&type=script&setup=true&lang=js"
export * from "./GoToLink.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GoToLink.vue?vue&type=style&index=0&id=12316ac2&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12316ac2",
  null
  
)

export default component.exports